<template>
  <div class="join">


    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
          <img :src="i" class="swiperImg">
      </swiper-slide>
    </swiper>

    
    <div class="titleTY" style="margin-top:60px;">
      <span class="titleTY_top">
        招聘
      </span>
      <span class="titleTY_bot">
        RECRUITING
      </span>
    </div>
    <!-- <div class="joinCon2" id="joinCon2" data-aos=""  data-aos-duration="1200">
      <div class="joinCon21 contentWidth">
        <div class="joinCon21_left">
          <div class="joinAbout">
            <span class="joinAbout_top">
              RECRUITING
            </span><br>
            <span class="joinAbout_bot">
              招聘
            </span>
            <p></p>
          </div>
        </div>
      </div>
    </div> -->
    
    <div class="joinCon3" id="joinCon3">
      <div class="joinCon31 contentWidth">
        <div class="joinCon31_left">
          <span v-for="(i,index) in jobJson" :class="'JoinList '+(joinlistIndex==index?'JoinCheck':'')" @click="JoinClick(index)">
            {{i.title}}
          </span>
        </div>
        <div class="joinCon31_right">
          <div  v-for="(i,index) in jobJson" v-if="joinlistIndex==index">
            <p v-for="(ii,index) in jobJson[joinlistIndex].cont">
              <span class="title">{{ii.name}}</span> 
              <span v-for="j in ii.text" class="text">{{j}}</span><br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'video.js/dist/video-js.min.css'




import ZSelect from '../modules/Zselect'
export default {
  name: 'join',
  components:{ZSelect},
  data () {
    return {
      player: null,
      bannerImg:[
        //require('../../assets/img/join/join001.jpg'),
        //require('../../assets/img/join/join002.jpg'),
        //require('../../assets/img/join/join003.jpg'),
        //require('../../assets/img/join/join004.jpg'),
        //require('../../assets/img/join/join005.jpg'),
        //require('../../assets/img/join/join006.jpg'),
        require('../../assets/img/join/joinBanner1.jpg'),
        require('../../assets/img/join/joinBanner2.jpg'),
        require('../../assets/img/join/joinBanner3.jpg'),
        require('../../assets/img/join/joinBanner4.jpg'),
        require('../../assets/img/join/joinBanner5.jpg'),
        // require('../../assets/img/join/joinBanner6.jpg'),
        // require('../../assets/img/join/banner1.jpg'),
        // require('../../assets/img/join/banner2.jpg'),
        // require('../../assets/img/join/banner3.jpg'),
        // require('../../assets/img/join/banner4.jpg'),
        // require('../../assets/img/join/banner5.jpg'),
        // require('../../assets/img/join/banner6.jpg'),
        // require('../../assets/img/join/banner7.jpg'),
      ],
      test1:'1',
      test2:'1',
      msgs: [{
        ids:1,
        value1:'我是1'
      },{
        ids:2,
        value1:'我是2'
      },{
        ids:3,
        value1:'我是3'
      },{
        ids:4,
        value1:'我是4'
      },],
      swiperOption:{
        loop:true,
        effect:'fade',
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      Con2:0,
      Con1:0,
      Con3:0,
      ImgHover:0,
      joinlistIndex:0,
      jobJson:[
        // 1
        {
          title:'客户经理',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、准确把握客户需求，充分调动内部资源，把控项目的执行进度和质量',
                '2、规划项目的执行效果，并能够拆解项目结果成为有效可监控数据',
                '3、参与全案的执行，熟悉并能够有效解决对执行过程中可能遇见的突发事件',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、3-4年公关，广告或营销行业的客户经验',
                '2、具备消费品客户服务经验 ',
                '3、拥有执行、创意能力，思维敏捷并拥有良好的沟通能力',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 2
        {
          title:'运营经理',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、制定所负责项目的年度、季度、月度运营计划，并按照计划领导团队完成各项任务指标',
                '2、与各合作方针对活动规则以及店铺运营情况来争取资源，有效达成销售目标',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、2年以上天猫运营管理经验',
                '2、熟悉电子商务的运营模式及电商平台各项推广工具',
                '3、具备系统的数据解读能力，前瞻性和统筹规划能力 ',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 3
        
        {
          title:'高级视觉设计师',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、带领设计团队完成公司重要的设计工作，全程监控项目创作过程，合理调配、使用相关设计资源',
                '2、能理解设计总监的创作要求，对设计总监委派的工作负责',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、美术、设计相关专业，本科以上学历',
                '2、具备优秀的视觉把控能力、项目理解能力及过人的创意思路，能以独到、精准的理解对品牌及运营策略进行成熟的视觉表现及完美的细节把握',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 4
        
        {
          title:'品牌传播经理',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、根据客户需求，负责制定品牌策略，年度公关策略',
                '2、进行整体品牌公关和数字传播，整合营销传播的Brief梳理、策略及创意制定、方案撰写、独立提案、执行内容和进度把控、报告及反馈等',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、学历本科及以上，4年及以上相关工作经验，重点快消、药品服务经验优先；媒体资源丰富者优先',
                '2、文字功底好，能撰写各类稿件、相关汇报材料、演讲稿等类型的文字资料',
                '3、擅长危机公关，及处理经验',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 5
        
        {
          title:'项目经理',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、全面参与完成月度生意计划，带领团队完成月度业绩指标；制定详细CPS表并监管，做好店铺全年、半年、季度与月度规划',
                '2、负责和小二进行沟通，争取活动资源',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、本科学历，1年以上店长工作经验，电子商务专业优先',
                '2、具备系统的数据解读能力，条理清晰，擅长归纳总结；优秀的学习、应用能力',
                '3、良好的沟通表达能力和统筹协调能力，强烈的自我驱动力',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 6
        
        {
          title:'文案策划',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、负责活动文案的策划、创意、撰写',
                '2、负责各类活动的组织、执行、跟踪和总结',
                '3、熟悉各种线上线下活动环节，有针对性的制定各种形式的活动，提升用户转化率、留存率',
              ]
            },
            {
              name:'任职资格',
              text:[
                '1、1年以上相关工作经验，本科以上学历',
                '2、具有较强的策划能力和文字功底，有活动策划及执行者经验优先',
              ]
            },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        // 7
        
        {
          title:'实习生',
          cont:[
            {
              name:'职位描述',
              text:[
                '1、保证每周工作4-5天，只接受应届本科毕业生',
                '2、熟悉互联网营销的基本套路 ',
                '3、有较好的策划能力和文案能力',
                '4、良好的沟通、协调能力 ',
                '5、有较强的抗压力',
                '6、传媒或广告专业，或对电商有浓厚兴趣者优先',
              ]
            },
            // {
            //   name:'任职资格',
            //   text:[
            //     '美术，设计相关专业，本科学历以上。',
            //     '具备优秀的视觉把控能力，项目理解能力以及过人的创意思路，能以独到，精准的理解对品牌及运营策略进行成熟的视觉表现及完美的细节把握。'
            //   ]
            // },
            {
              text:[
                '作品及简历投递：ig-hr@intelinkgroup.com'
              ]
            }
          ]
        },
        
      ],
    }
  },
  beforeDestroy() {
    if (this.player) {
            this.player.dispose()
        }
  },
  methods: {
    JoinClick(data){
      this.joinlistIndex = data;
    },
    onPlayerReady(player) {
      this.player = player
      console.log('播放器已初始化', player)
    }
  },
  mounted(){
    

    
    var joinCon2 = document.getElementById('joinCon2')
    var joinCon3 = document.getElementById('joinCon3')
    var joinCon2Top = 0;//距离顶部位置
    var joinCon3Top = 0;//距离顶部位置
    var that = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.joinHeight || document.body.joinHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      //滚动条到底部的条件
      console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+joinCon2.offsetTop);
      console.log("距顶部"+scrollHeight/windowHeight);
      if(scrollHeight/windowHeight<1.3){//如果宽高比不合适就不动画了
        that.Con1 = 6;
        that.Con2 = 6;
        that.Con3 = 9;
        console.log('主流撒旦')
      }else{
        window.onscroll = function(){
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
          //变量windowHeight是可视区的高度
          var windowHeight = document.documentElement.joinHeight || document.body.joinHeight;
          //变量scrollHeight是滚动条的总高度
          var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
          //滚动条到底部的条件
          
          joinCon2Top = joinCon2.offsetTop-scrollTop;
          if(joinCon2Top<700 && joinCon2Top>600){
            that.Con2 = 1;
          }
          else if(joinCon2Top<=600 && joinCon2Top>500){
            that.Con2 = 2;
          }
          else if(joinCon2Top<=500 && joinCon2Top>400){
            // that.Con2 = 42.81;
            that.Con2 = 3;
          }
          else if(joinCon2Top<=400 && joinCon2Top>300){
            // that.Con2 = 42.81;
            that.Con2 = 4;
          }
          else if(joinCon2Top<=300 && joinCon2Top>200){
            // that.Con2 = 42.81;
            that.Con2 = 5;
          }
          else if(joinCon2Top<=200 && joinCon2Top>100){
            // that.Con2 = 42.81;
            that.Con2 = 6;
          }
          else if(joinCon2Top<=100){
            that.Con2 = 7;
          }
          else{
            that.Con2 = 0;
          }
          joinCon3Top = joinCon3.offsetTop-scrollTop;
          console.log(joinCon3Top);
          if(joinCon3Top<900 && joinCon3Top>800){
            that.Con3 = 1;
          }
          else if(joinCon3Top<=800 && joinCon3Top>400){
            that.Con3 = 2;
          }
          else if(joinCon3Top<=400 && joinCon3Top>100){
            that.Con3 = 3;
          }
          else if(joinCon3Top<=100 && joinCon3Top>-200){
            that.Con3 = 4;
          }
          else if(joinCon3Top<=-200 && joinCon3Top>-400){
            that.Con3 = 5;
          }
          else if(joinCon3Top<=-400 && joinCon3Top>-600){
            that.Con3 = 6;
          }
          else if(joinCon3Top<=-600 && joinCon3Top>-900){
            that.Con3 = 7;
          }
          else if(joinCon3Top<=-900 && joinCon3Top>-1100){
            that.Con3 = 8;
          }
          else if(joinCon3Top<=-1100){
            that.Con3 = 9;
          }
          else{
            that.Con3 = 0;
          }
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.join{
  padding-bottom: 0px;
  min-height: calc(100vh - 150px);
  .swiperImg{
    width: 100%;
    min-width: 1200px;
  }
  /*//轮播入场*/
  .swiper-container{
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
    width: 1200px;
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  // 第二屏
  .joinCon2{
    box-sizing: border-box;
    height: 100px;
    position: relative;
    margin:80px 0;
    margin-top: 0 !important;
    .joinAbout{
      box-sizing: border-box;
      display: inline-block;
      width: 580px;
      height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      // opacity: 0;
      .joinAbout_top{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .joinAbout_bot{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/join/down.png') no-repeat 320px;
        font-weight: 900;
      }
      p{
        display: inline-block;
        background: #0168b7;
        width: 40px;
        height: 2px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
      }
    }

  }

  
  .joinCon3{
    box-sizing: border-box;
    position: relative;
    
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    .joinCon31{
      box-sizing: border-box;
      height: auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      /*background: #fafafa;*/
      .joinCon31_left{
        box-sizing: border-box;
        width: 17%;
        height: 100%;
        /*margin-right: 20px;*/
        .JoinList{
          cursor:pointer;
          color: #1e2128;
          display: inline-block;
          width: 100%;
          height: 36px;
          font-size: 14px;
          text-align: left;
          line-height: 36px;
          font-weight: 400;
          letter-spacing: 2px;
          box-sizing: border-box;
/*          border-radius: 10px;*/
          margin-bottom: 10px;
          padding-left: 20px;
        }
        /*.JoinList:nth-of-type(2n+1){
          background: #e0e0e0;
        }
        .JoinList:nth-of-type(2n){
          background: #f0f0f0;
        }*/
        
        .JoinList:after{
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          content: '';
          display: inline-block;
          widows: 0;
          height: 0;
          border-width: 12px;
          border-style: solid;
          border-color:transparent transparent transparent transparent;
          opacity: 0;
          pointer-events: none;
        }
        .JoinCheck{
          color: #fff;
          color: #0068b7;
          /*background: #0168b7 !important;*/
          position: relative;
          transition: all 0.4s;
          -moz-transition: all 0.4s;	/* Firefox 4 */
          -webkit-transition: all 0.4s;	/* Safari 和 Chrome */
          -o-transition: all 0.4s;	/* Opera */
          background: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0.2)), to(#F2F6FC));
          /*background: #F2F6FC;*/
          &::before{
            content: '';
            display: inline-block;
            background: #0068b7;
            width: 3px;
            height: 16px;
            position: absolute;
            left: 4px;
            top: 10px;
          }
        }
        /*.JoinCheck:after{
          pointer-events: none;
          position: absolute;
          top: 0;
          left: 100%;
          bottom: 0;
          margin: auto;
          content: '';
          display: inline-block;
          widows: 0;
          height: 0;
          border-width: 12px;
          border-style: solid;
          border-color:transparent transparent transparent #0168b7;
          transition: all 0.3s;
          -moz-transition: all 0.3s;
          -webkit-transition: all 0.3s;
          -o-transition: all 0.3s;
          opacity: 1;
        }*/
      }
      .joinCon31_right{
        box-sizing: border-box;
        width: 70%;
        overflow: hidden;
        height: auto;
        
        font-size: 14px;
        padding: 20px;
        min-height: 100px;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        background: #F2F6FC;
        background: -webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0.2)), to(#F2F6FC));
        p{
          margin-bottom: 10px;
          margin-top: 0;
          .title{
            font-size: 14px;
            display: block;
            color: #1e2128;
            margin-bottom: 10px;
          }
          .text{
            margin:0px 0 10px 0px;
            display: block;
            color: #80888f;
          }
        }
      }
    }
    .joinCon31:after{
      pointer-events: none;
      content: '';
      clear: both;
    }
  }
  

}
</style>



// WEBPACK FOOTER //
// src/components/views/join.vue